"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./flot.module"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/ng2modules-flot/index.js
// module id = ../../../../ng2modules-flot/index.js
// module chunks = 3